import { atom } from 'jotai';

/**
 * Atom to track if the Session Chat Sidebar spotlight (step 2/3) is open.
 * Set to true when user clicks "Next" on the Session Ask Heidi spotlight (step 1/3).
 */
export const sessionChatSidebarSpotlightOpenAtom = atom<boolean>(false);

/**
 * When true, the next in-session stream that completes should open the Sources spotlight.
 * Set to true when user clicks "Next" on Session Chat Sidebar spotlight (step 2/3); cleared when stream completes.
 */
export const pendingSourcesSpotlightAfterStreamAtom = atom<boolean>(false);

/**
 * Atom to track if the Sources spotlight (step 3/3) is open.
 * Set to true when user clicks "Next" on the Session Chat Sidebar spotlight, or when stream completes (if pendingSourcesSpotlightAfterStreamAtom).
 */
export const sourcesSpotlightOpenAtom = atom<boolean>(false);
